import { Injectable } from '@angular/core';
import { ServiceCallUtilsService } from '../service-call-utils.service';
import { constants } from '../constants';

@Injectable({
  providedIn: 'root'
})
export class ReleaseLineEquipService {
  listLineData:any;
  listQuestions:any;
  constructor(private serviceCallUtilsService: ServiceCallUtilsService) { }
   
   /**
   * Description: Método que llama el servicio web para la lista de las preguntas con sus respectivas opciones de respuesta
   * Autor: Steven Sterling
   * @param documentId número del documento de identidad
   * @param msisdn numero de móvil
   * @param customerId numero de identificador del usuario
   * @return Listado de terminos y condiciones
   */
  getReleaseQuestionsList(documentId, msisdn, customerId){
   return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RELEASE_LINE_VALIDATION_QUESTIONS, { "identification": documentId, "msisdn": msisdn, "customerAccountId": customerId });
  }
   /**
   * Description: Método que llama el servicio web para realizar la validación de las preguntas
   * Autor: Steven Sterling
   * @param N/A
   * @return Listado de terminos y condiciones
   */
  validateQuestions(answers){
   return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RELEASE_VALIDATE_QUESTIONS, answers);
  }

  /**
   * Description: Método que llama el servicio web de obtener todas las lineas del usuario
   * Autor: Diego Diaz
   * @param documentId cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  getAllUserLines(customerAccountId) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_ALL_USER_LINES, { "customerAccountId": customerAccountId });
  }

 /**
   * Description: Método que llama el servicio web de obtener el imei marca y modelo de una linea
   * Autor: Diego Diaz
   * @param phone cédula del usuario
   * @return Mensaje de confirmación de la validación
   */
  getInfoLines(phone) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_GET_IMEI_LINES, { "identificationValue": phone });
  }


   /**
   * Description: Método que llama el servicio web de crear el ticket de liberación
   * Autor: Diego Diaz
   * @param jsonData json con todos los parámetros requeridos
   * @return Mensaje de confirmación del ticket
   */
  releaseLineEquipRequest(jsonData) {
    return this.serviceCallUtilsService.callSecuredPostWebService(constants.ENDPOINT_RELEASE_REQUEST, jsonData);
  }

}
